module.exports = __webpack_public_path__ + "static/jeff-6cdfbd062f05a48e0f1b9a9649f5901f.jpg";